export const cardsAsGrid = (cards, columns) => cards.reduce((grid, card, index) => {
  const rowIndex = Math.floor(index / columns)
  const columnIndex = index % columns
  const currentRow = grid[rowIndex] || []
  currentRow[columnIndex] = card
  grid[rowIndex] = currentRow
  return grid
}, [])